import gql from 'graphql-tag'

export default gql`
mutation createTrackingJandT($labelId: String!) {
  createTrackingJandT(labelId: $labelId) {
    _id
    sendHook
  }
}
`


// WEBPACK FOOTER //
// ./src/graphql/mutations/CreateTrackingJandtApi.js